<template lang="pug">
  .message-item(:class="message_class")
    .message-body {{message.body}}
    .message-footer
      .message-chater {{message.chater_name}}
      .message-date {{message_date}}

</template>

<script>
import moment from 'moment';
import DateMethods from "../../mixins/DateMethods";

export default {
name: "MessageItem",
  mixins: [DateMethods],
  props: {
    message: {
      type: Object,
      default: {
        id: 0,
        body: 'Default body of message.',
        msg_type: 'text',
        unread: false,
        chater_name: 'Default Chater',
        created_at: new Date(),
      }
    }
  },
  computed:{
    message_date(){
      return this.formatted_date(this.message.created_at)
    },
    message_class(){
      let css = [];
      css.push(this.message_my_class);
      css.push(this.message_unread_class);
      css.push(this.message_type_class);

      return css.join(' ');
    },
    message_unread_class(){
      return this.message.unread ? 'unread' : ''
    },
    message_my_class(){
      return this.message.my_message ? 'my-message' : ''
    },
    message_type_class(){
      return `msg-type-${this.message.msg_type}`
    },
  },
}
</script>

<style scoped>
  .message-item {
    padding: 10px;
    padding-right: 30px;
    border-bottom: solid 1px #e4e7ea;
  }

  .message-item.my-message {
    padding-left: 30px;
    padding-right: 10px;
  }

  .message-item.unread {
    border-left: 2px solid #ffe3c1;
    background-color: #fff6f1;
  }

  .message-item.msg-type-query {
    border-left: 2px solid #ff9f2c;
    background-color: #fff2d1;
  }

  .message-item.unread.msg-type-query {
    /*border-left: 2px solid #ffe3c1;*/
    background-color: #ffcdb1;
  }

  .message-body {
    font-size: 14px;

  }
  .message-chater, .message-date {
    font-size: 12px;
    color: #aeb2b7;
  }

  .message-footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
</style>